import React from "react";
import { motion } from "framer-motion";

import deloitteLogo from "../assets/companies/deloitte.png";
import aitechLogo from "../assets/companies/aitech.png";
import visionmakersLogo from "../assets/companies/visionmakers.png";
// import gen6Logo from "../assets/companies/gen6.png";
// import tenexLogo from "../assets/companies/tenex.png";
import binanceLogo from "../assets/companies/binance.png";
import okxLogo from "../assets/companies/okx.png";
import sambanovaLogo from "../assets/companies/sambanova.avif";
import digitaloceanLogo from "../assets/companies/digitalocean.png";
import upholdLogo from "../assets/companies/uphold.png";
import "../styles/Hero.css";

// Ordered by career relevance: employers first, then strategic collaborators
const companies = [
  { src: aitechLogo, alt: "Aitech" },
  { src: deloitteLogo, alt: "Deloitte" },
  { src: binanceLogo, alt: "Binance" },
  { src: okxLogo, alt: "OKX" },
  { src: sambanovaLogo, alt: "SambaNova Systems" },
  { src: digitaloceanLogo, alt: "DigitalOcean" },
  { src: upholdLogo, alt: "Uphold" },
  { src: visionmakersLogo, alt: "Visionmakers" },
];

const Hero = () => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  const logosContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.04,
      },
    },
  };

  const logoFade = {
    hidden: { opacity: 0, scale: 0.92 },
    show: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section id="home" className="hero">
      <div className="hero-smoke" aria-hidden="true">
        <span className="hero-smoke-blob hero-smoke-blob-1" />
        <span className="hero-smoke-blob hero-smoke-blob-2" />
        <span className="hero-smoke-blob hero-smoke-blob-3" />
        <span className="hero-smoke-blob hero-smoke-blob-4" />
      </div>

      <div className="hero-inner">
        <motion.div
          className="hero-text"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
        >
          <motion.p className="hero-eyebrow" variants={fadeUp}>
            TECH LEAD • FULL STACK • AI • MACHINE LEARNING
          </motion.p>

          <motion.h1 className="hero-title" variants={fadeUp}>
            I make broken systems <span className="blue">work</span> and build
            new ones with <span className="blue">zero loose ends</span>.
          </motion.h1>

          <motion.p className="hero-subtitle" variants={fadeUp}>
            Engineer by trade, hustler by habit. I like taking messy problems,
            shipping clean systems, and making them feel effortless for the
            people using them.
          </motion.p>

          <motion.div
            className="hero-companies"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
          >
            <span className="hero-companies-label">Collaborated with teams at</span>
            <motion.div
              className="hero-companies-logos"
              variants={logosContainer}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.1 }}
            >
              {companies.map((company) => (
                <motion.div
                  key={company.alt}
                  variants={logoFade}
                  className="hero-company-logo-slot"
                >
                  <img
                    src={company.src}
                    alt={company.alt}
                    className="hero-company-logo"
                    loading="lazy"
                    decoding="async"
                  />
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
